var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.8464 21.5149v-3.5025c.034-.4316-.0244-.8654-.171-1.2727-.1467-.4073-.3784-.7787-.6797-1.0895 2.8418-.3167 5.8284-1.3937 5.8284-6.33522-.0002-1.26358-.4863-2.47871-1.3576-3.39388.4126-1.1055.3834-2.32744-.0814-3.41199 0 0-1.0679-.31676-3.5387 1.33946-2.0743-.56219-4.2609-.56219-6.33525 0-2.47075-1.65622-3.53869-1.33946-3.53869-1.33946-.46485 1.08455-.49402 2.30649-.08145 3.41199-.87777.92196-1.36432 2.14807-1.35755 3.42103 0 4.90527 2.98661 5.98227 5.82844 6.33527-.2978.3077-.52741.6746-.67399 1.0769-.14657.4023-.2068.831-.17676 1.2581v3.5025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5112 18.7998c-4.52523 1.3576-4.52523-2.2626-6.3353-2.7151",
    stroke: "#313131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.fbf36f37.svg";
export { ForwardRef as ReactComponent };